import api from './api'

export interface Team {
  id: string
  name: string
  description?: string
  assignmentMethod?: 'MANUAL' | 'AUTO_ROUND_ROBIN'
  isDefault?: boolean
  tenantId?: string
  createdAt: string
  updatedAt: string
  users?: Array<{
    id: string
    name: string | null
    email: string
  }>
  _count?: {
    conversations: number
  }
}

export interface CreateTeamData {
  name: string
  description?: string
  userIds?: string[]
  isDefault?: boolean
}

export interface UpdateTeamData {
  name?: string
  description?: string
  userIds?: string[]
  isDefault?: boolean
}

export const teamsApi = {
  /**
   * Get all teams for the current tenant
   */
  async getTeams(tenantId?: string): Promise<Team[]> {
    const response = await api.get<{ success: boolean; teams: Team[] }>('/teams', {
      headers: tenantId ? { 'x-tenant-id': tenantId } : undefined,
      params: tenantId ? { tenantId } : undefined,
    })
    return response.data.teams
  },

  /**
   * Get a single team by ID
   */
  async getTeamById(teamId: string): Promise<Team> {
    const response = await api.get<{ success: boolean; team: Team }>(`/teams/${teamId}`)
    return response.data.team
  },

  /**
   * Create a new team
   */
  async createTeam(data: CreateTeamData): Promise<Team> {
    const response = await api.post<{ success: boolean; team: Team }>('/teams', data)
    return response.data.team
  },

  /**
   * Update a team
   */
  async updateTeam(teamId: string, data: UpdateTeamData): Promise<Team> {
    const response = await api.put<{ success: boolean; team: Team }>(`/teams/${teamId}`, data)
    return response.data.team
  },

  /**
   * Delete a team
   */
  async deleteTeam(teamId: string): Promise<void> {
    await api.delete(`/teams/${teamId}`)
  },
}

